module.exports = __webpack_public_path__ + "static/media/salmon.4fbf494e.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/salmon.jpeg
// module id = 202
// module chunks = 0